import { useEffect, useState } from "react";
import AdminModal from "../../../core/admin/adminModal";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useWatches } from "../../../../context/watchProvider";
import Review from "../../../core/review";
import { formatPhoneNumber, parseTimestamp } from "../../../../utils/functions";
import AdminButton from "../../../core/admin/adminButton";
import AdminCallout from "../../../core/admin/adminCallout";
import AdminConfirm from "../../../core/admin/adminConfirm";
import AdminDetails from "../../../core/admin/adminDetails";
import { AdminLoading } from "../../../core/admin/adminSpinner";
import { IRequest } from "./requests";
import { IReview } from "./reviews";

export default function RequestDetailsModal({ close, request, goodToast, badToast, refresh }: { close: () => void, request: IRequest, refresh: () => Promise<null>, goodToast: () => void, badToast: () => void }) {

    const { getAdvertiser } = useWatches();

    const [loading, setLoading] = useState(false);
    const [advertiser, setAdvertiser] = useState<{ [key: string]: any; id: string; } | null>(null);
    const [review, setReview] = useState<IReview | null>(null);
    const [edit, setEdit] = useState(false);
    const [cancel, setCancel] = useState(false);

    useEffect(() => {
        doGetAdvertiser();
        doGetReview();
        // eslint-disable-next-line
    }, []);

    const doGetAdvertiser = async () => {
        setLoading(true);
        const adv = await getAdvertiser(request.advertiser);
        if (!adv) {
            setLoading(false);
            return null;
        }
        setAdvertiser(adv);
        setLoading(false);
    }

    const doGetReview = async () => {
        try {
            setLoading(true);
            if(!request.review){
                return null;
            }
            const docRef = doc(db, "reviews", request?.review);
            const docSnap = await getDoc(docRef);
            if (!docSnap.exists()) {
                setLoading(false);
                return null;
            }
            setReview({
                id: docSnap.id,
                advertiser: docSnap.data().advertiser,
                createdAt: docSnap.data().createdAt.toDate(),
                hidden: docSnap.data().hidden,
                rate: docSnap.data().rate,
                userId: docSnap.data().userId,
                watch: docSnap.data().watch,
                review: docSnap.data().review
            })
            setLoading(false);
            return null;
        } catch (error) {
            console.log(error);
            setLoading(false);
            return null;
        }
    }

    const handleHideOperation = async () => {
        try {
            if(!review){
                return null;
            }
            setLoading(true);

            const docRef = doc(db, "reviews", review.id);
            await updateDoc(docRef, { hidden: true });

            const docRef2 = doc(db, "reviewsrequests", request.id);
            await updateDoc(docRef2, { solved: true });

            setLoading(false);
            goodToast();
            await refresh();
            close();
        } catch (error) {
            console.log(error);
            badToast();
            setLoading(false);
        }
    }

    const handleCancelOperation = async () => {
        try {
            if(!request){
                return null;
            }
            setLoading(true);

            const docRef = doc(db, "reviewsrequests", request.id);
            await updateDoc(docRef, { solved: true });

            setLoading(false);
            goodToast();
            await refresh();
            close();
        } catch (error) {
            console.log(error);
            badToast();
            setLoading(false);
        }
    }

    return (
        <AdminModal
            close={close}
            title="Solicitação de exclusão"
            subtitle={parseTimestamp(request.createdAt) ? `Enviada em ${parseTimestamp(request.createdAt)}` : undefined}
            footer={
                loading ?
                    undefined
                    : edit ?
                        <AdminConfirm
                            className="w-full"
                            message={request.solved ? "Deseja exibir essa avaliação?" : "Deseja esconder essa avaliação?"}
                            cancelLabel="Cancelar"
                            danger={!request.solved}
                            onConfirm={handleHideOperation}
                            onCancel={() => setEdit(false)}
                        />
                        : cancel ?
                            <AdminConfirm
                                className="w-full"
                                message="Deseja cancelar a solicitação sem alterar a avaliação?"
                                cancelLabel="Voltar"
                                onConfirm={handleCancelOperation}
                                onCancel={() => setCancel(false)}
                            />
                            :
                            <>
                                <AdminButton variant="secondary" onClick={() => setCancel(true)}>Cancelar solicitação</AdminButton>
                                <AdminButton variant={request.solved ? "primary" : "danger"} onClick={() => setEdit(true)}>{request.solved ? "Exibir avaliação" : "Esconder avaliação"}</AdminButton>
                            </>
            }
        >
            {
                loading ?
                    <AdminLoading />
                    :
                    <div className="flex flex-col gap-6">
                        <AdminCallout tone="warning" title="Motivo informado pelo anunciante">
                            <p className="break-words">{request.reason}</p>
                        </AdminCallout>
                        {
                            review ?
                            <section>
                                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Sobre a avaliação</h3>
                                <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
                                    <Review review={{createdAt: review?.createdAt, rate: review?.rate, review: review?.review}}/>
                                </div>
                            </section>
                            : null
                        }
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <section>
                                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Sobre o anunciante</h3>
                                <AdminDetails
                                    columns={1}
                                    items={[
                                        { label: "Nome", value: advertiser?.name },
                                        { label: "E-mail", value: advertiser?.email },
                                        { label: "Telefone", value: formatPhoneNumber(advertiser?.phoneNumber) },
                                    ]}
                                />
                            </section>
                            <section>
                                <h3 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-3">Sobre o relógio</h3>
                                <AdminDetails columns={1} items={[{ label: "ID", value: review?.watch ? <span className="font-mono text-xs">{review?.watch}</span> : "" }]} />
                            </section>
                        </div>
                    </div>
            }
        </AdminModal>
    )
}
